import { render, staticRenderFns } from "./Biblioteca.vue?vue&type=template&id=20b085d8"
import script from "./Biblioteca.vue?vue&type=script&lang=js"
export * from "./Biblioteca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports